/* 1) Makes duplicate custom-element registrations a no-op (non-configurable,
      because the theme's CDN script re-pins the native define).
   2) The fallback bundle (a-custom-elements.js) dies part-way when it runs in
      deferred order but executes cleanly once the page has settled - so if the
      core elements are still missing after window load, the bundle is loaded
      once more; the guard makes the second pass safe. */
(function () {
  var reg = window.customElements;
  if (!reg) return;
  if (!(reg.define && reg.define.__clyroGuarded)) {
    var raw = reg.define.bind(reg);
    var guarded = function (name, ctor, opts) {
      if (reg.get(name)) return;
      try { return raw(name, ctor, opts); } catch (e) {}
    };
    guarded.__clyroGuarded = true;
    try {
      Object.defineProperty(reg, 'define', { value: guarded, configurable: false, writable: false });
    } catch (e) {
      try { reg.define = guarded; } catch (e2) {}
    }
    try { CustomElementRegistry.prototype.define = guarded; } catch (e) {}
  }
  var tries = 0;
  function rerun() {
    if (reg.get('product-form') && reg.get('cart-drawer') && reg.get('variant-selects')) return;
    if (tries >= 3) return;
    tries += 1;
    var existing = document.querySelector('script[src*="a-custom-elements"]');
    if (!existing || !existing.src) return;
    var s = document.createElement('script');
    s.src = existing.src.split('#')[0] + (existing.src.indexOf('?') > -1 ? '&' : '?') + 'clyro_rerun=' + tries;
    s.onload = function () { setTimeout(rerun, 700); };
    document.head.appendChild(s);
  }
  if (document.readyState === 'complete') {
    setTimeout(rerun, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(rerun, 300); });
  }
})();
